import common from "../whaleshark/common.json";
import modals from "../whaleshark/modals.json";

const sources = {
  common,
  modals,
};

export default sources;
